import InternationalPhoneNumberInput from 'javascripts/components/InternationalPhoneNumberInput';
import React from 'react';
import cx from 'classnames';
import store from 'javascripts/store';

function PhoneNumberField() {
  if(store.donateForm.managementMode) return null;

  return (
    <div className={cx('phone-number-fields', {'hidden': railsEnv != 'test'})}>
      <InternationalPhoneNumberInput
        defaultCountry={store.donateForm.country}
        defaultNumber={store.donateForm.phoneNumber.hiddenFieldValue}
        inputClassNames='rounded-br-none rounded-bl-none'
        inputWrapperClassNames='mb-0'
        onChange={phoneNumber => store.donateForm.phoneNumber.hiddenFieldValue = phoneNumber}
        showOptionalPlaceholder={true}
      />
      <div className='input-wrapper anonymous custom-check mt-0 border border-solid border-grey-40 border-t-0 p-1 rounded rounded-tl-none rounded-tr-none bg-grey-10'>
        <input
          className='phone-number-consent'
          defaultChecked={store.donateForm.phoneNumberConsentGranted}
          id={`${store.donateForm.campaignSlug}_donation_form_phone_number_consent`}
          onChange={e => store.donateForm.phoneNumberConsentGranted = e.target.checked}
          type='checkbox'
        />
        <label
          className='phone-number-consent-granted-label text-xs leading-tight'
          htmlFor={`${store.donateForm.campaignSlug}_donation_form_phone_number_consent`}
        >
          <span className='h80'>
            I want to hear from charity:&nbsp;water by text/SMS about my giving and how I can&nbsp;help.
            <br />
            <span className='italic text-grey-50 font-normal h80'>
              Std. msg & data rates apply.
            </span>
          </span>
        </label>
      </div>

      <div className='phone-number-errors-container' />
    </div>
  );
}

export default PhoneNumberField;
